module.exports = __webpack_public_path__ + "img/audioplay.32b2f3c2.png";